export default function HowItWorks() {
  const steps = [
    {
      id: 'step-1',
      number: '01',
      title: 'Paste the review',
      description:
        'Copy any review from Google or TripAdvisor and paste it in. Select the star rating, your restaurant name, and the tone you want — professional, friendly, apologetic, or grateful.',
      icon: '📋',
    },
    {
      id: 'step-2',
      number: '02',
      title: 'AI crafts the reply',
      description:
        'Our AI — trained on thousands of hospitality responses — writes a reply that addresses the reviewer\'s specific points, sounds human, and ends with a genuine invitation back. No clichés. No templates.',
      icon: '✨',
    },
    {
      id: 'step-3',
      number: '03',
      title: 'Copy and post',
      description:
        'Hit Copy, paste directly into Google or TripAdvisor, and post. Your reply history is saved to your account so you can review, refine, and track every response over time.',
      icon: '🚀',
    },
  ];

  return (
    <section id="how-it-works" className="py-20 lg:py-28">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="section-label mb-3">How it works</p>
          <h2 className="font-serif text-display-md mb-4" style={{ color: 'var(--foreground)' }}>
            A professional reply in{' '}
            <span style={{ color: 'var(--primary)', fontStyle: 'italic' }}>three steps</span>
          </h2>
          <p className="text-base leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
            No training required. No templates to fill in. Just paste, generate, and post.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps?.map((step, i) => (
            <div
              key={step?.id}
              className="relative card-elevated p-8 fade-in"
              style={{ animationDelay: `${i * 120}ms` }}
            >
              <div
                className="text-5xl font-serif font-bold mb-4 leading-none"
                style={{ color: 'rgba(193, 68, 14, 0.12)' }}
              >
                {step?.number}
              </div>
              <div className="text-3xl mb-4">{step?.icon}</div>
              <h3 className="text-lg font-semibold mb-3" style={{ color: 'var(--foreground)' }}>
                {step?.title}
              </h3>
              <p className="text-sm leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
                {step?.description}
              </p>
              {i < steps?.length - 1 && (
                <div
                  className="hidden md:block absolute top-1/2 -right-4 w-8 h-px"
                  style={{ backgroundColor: 'var(--border)' }}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}